import React from 'react';
import LoadingSpinner from './loadingSpinner'
import C18Select01 from './C18Select01'
import {wsTrans,getParamId2} from '../utils/utils'
import {cl, constant, globs, getTime,getRandomString,
  dateToDisplayDate} from '../../components/utils/utils';
import {dbVals,sendArray} from '../../components/utils/http';
import {loadZonesInfo,getSiteName,getZoneName} from './C18utils'
import {sendSocket,} from '../../components/utils/ws';

class C18SimpleSetup00 extends React.Component{
  constructor(props) {
    super(props);
    this.state={
      simpleEqTypes:[],
    }
    this.simpEq=[
      {n:"None",t:constant.EQ_NONE,m:0},
      {n:"NotUsed",t:constant.EQ_NONE,m:0},
      {n:"AirCond",t:constant.EQ_ONOFF,m:0},
      {n:"AirCurt",t:constant.EQ_ONOFF,m:0},
      {n:"Alarm",t:constant.EQ_ONOFF,m:0},
      {n:"BlackOut",t:constant.EQ_CURT,m:0},
      {n:"BoomIrr",t:constant.EQ_ONOFF,m:0},
      {n:"BottomHt",t:constant.EQ_ONOFF,m:0},
      {n:"C02Gen",t:constant.EQ_CO2,m:0},
      {n:"C02Inj",t:constant.EQ_CO2,m:0},
      {n:"CeilFan",t:constant.EQ_ONOFF,m:0},
      {n:"Curtain",t:constant.EQ_CURT,m:0},
      {n:"DeHum",t:constant.EQ_ONOFF,m:0},
      {n:"DLI",t:constant.EQ_HID,m:0},
      {n:"Dripper",t:constant.EQ_ONOFF,m:0},
      {n:"Dump",t:constant.EQ_ONOFF,m:0},
      {n:"ElecLeaf",t:constant.EQ_ONOFF,m:0},
      {n:"Endwall",t:constant.EQ_ONOFF,m:0},
      {n:"EvapHFan",t:constant.EQ_ONOFF,m:0},
      {n:"EvapLFan",t:constant.EQ_ONOFF,m:0},
      {n:"EvapPump",t:constant.EQ_ONOFF,m:0},
      {n:"ExhFan",t:constant.EQ_ONOFF,m:0},
      {n:"ExhHigh",t:constant.EQ_ONOFF,m:0},
      {n:"ExhLow",t:constant.EQ_ONOFF,m:0},
      {n:"FanEnbl",t:constant.EQ_ONOFF,m:0},
      {n:"FanSpeed",t:constant.EQ_VAROUT,m:0},
      {n:"FogFan",t:constant.EQ_ONOFF,m:0},
      {n:"Fogger",t:constant.EQ_ONOFF,m:0},
      {n:"Growlite",t:constant.EQ_HID,m:0},
      {n:"HAF",t:constant.EQ_ONOFF,m:0},
      {n:"HeaterH",t:constant.EQ_ONOFF,m:0},
      {n:"HeaterL",t:constant.EQ_ONOFF,m:0},
      {n:"HeatVlv",t:constant.EQ_ONOFF,m:0},
      {n:"HotWater",t:constant.EQ_ONOFF,m:0},
      {n:"InDamper",t:constant.EQ_ONOFF,m:0},
      {n:"InShuttr",t:constant.EQ_ONOFF,m:0},
      {n:"IrrMastr",t:constant.EQ_IRR,m:0},
      {n:"IrrValve",t:constant.EQ_IRR,m:0},
      {n:"JetFan",t:constant.EQ_ONOFF,m:0},
      {n:"MastrPmp",t:constant.EQ_PUMP,m:0},
      {n:"Mister",t:constant.EQ_ONOFF,m:0},
      {n:"PadPump",t:constant.EQ_ONOFF,m:0},
      {n:"PadVent",t:constant.EQ_VENT,m:0},
      {n:"pHDN",t:constant.EQ_ONOFF,m:0},
      {n:"PhosPh",t:constant.EQ_ONOFF,m:0},
      {n:"pHUP",t:constant.EQ_ONOFF,m:0},
      {n:"RadHeat",t:constant.EQ_ONOFF,m:0},
      {n:"RdgeVent",t:constant.EQ_VENT,m:0},
      {n:"Shade",t:constant.EQ_CURT,m:0},
      {n:"ShutrFan",t:constant.EQ_ONOFF,m:0},
      {n:"Shutter",t:constant.EQ_ONOFF,m:0},
      {n:"SideVent",t:constant.EQ_VENT,m:0},
      {n:"SlabHeat",t:constant.EQ_ONOFF,m:0},
      {n:"StdNone",t:constant.EQ_NONE,m:0},
      {n:"StdOnOff",t:constant.EQ_ONOFF,m:0},
      {n:"StdIrr",t:constant.EQ_IRR,m:0},
      {n:"StdCO2",t:constant.EQ_CO2,m:0},
      {n:"StdHID",t:constant.EQ_HID,m:0},
      {n:"StdMZone",t:constant.EQ_MZONE,m:0},
      {n:"StdPump",t:constant.EQ_PUMP,m:0},
      {n:"StdFVlv",t:constant.EQ_FVALVE,m:0},
      {n:"StdVent",t:constant.EQ_VENT,m:0},
      {n:"StdCurt",t:constant.EQ_CURT,m:0},
      {n:"StdMixV",t:constant.EQ_MIXV,m:0},
      {n:"StdMicZo",t:constant.EQ_MZONE2,m:0},
      {n:"StdGnPid",t:constant.EQ_GEN_PID,m:0},
      {n:"StdVrOut",t:constant.EQ_VAROUT,m:0},
      {n:"StdMxvAn",t:constant.EQ_MIXV_AN,m:0},
      {n:"StdDliA",t:constant.EQ_DLI_A,m:0},
      {n:"Vent",t:constant.EQ_VENT,m:0},
      {n:"WetWall",t:constant.EQ_ONOFF,m:0},
      {n:"(2ndChn)",t:constant.EQ_2ND_VENT,m:0},
    ]
    this.simpEq.forEach((e,i)=>{e.i=i})// until this is finalized
    this.twoChan=[
      constant.EQ_VENT,
      constant.EQ_CURT,
      constant.EQ_MIXV,
      constant.EQ_MZONE2,
      constant.EQ_GEN_PID,
    ]
  }


  componentWillUnmount=()=>{
//     this.subscribe_newData.remove()
//     this.subscribe_operationProgress.remove()
//     this.subscribe_toClientEvent.remove()
  }

  componentDidMount=async()=>{
//     window.addEventListener('beforeunload', this.saveSearch);
    await this.loadInfo()
    this.setBreadCrumbs()
    this.subscribe_savePageEvent=globs.events
      .subscribe("savePageEvent",this.saveTypes)
//     globs.events.publish("savePageEnable",true)
  }

  setBreadCrumbs=()=>{
    let pa=this.props.parms
    let siteName=getSiteName(pa.site)
    let zoneName=getZoneName(pa.zone)
//     cl(pa)
    if(pa){
      pa.onChange(
        {
          cmd: "breadcrumbs",
          data:
            {breadcrumbs: [
              {t:"Sites", url:"/usa/c18/sites"},
              {t:siteName, url:`/usa/c18/sites/${pa.site}`},
              {t:zoneName, url:`/usa/c18/sites/${pa.site}/zones/${pa.zone}`},
              {t:"Simple Setup", url:`/usa/c18/sites/${pa.site}/zones/${pa.zone}/simpleSetup`},
            ]},
        },
      )
    }
  }

  saveTypes=async(cmd)=>{
    let st=this.state
    let pa=this.props.parms
    cl(pa)
    let types=st.simpleEqTypes.slice(0)
    while([0,1].includes(+types[types.length-1])){types.pop(1)}
    cl(types)
    types.push(0)// add a none to the end
    let data={zoneId:pa.zone,simpleSetupTypes:types}
    await wsTrans("usa", {cmd: "cRest", uri: "/s/zones", method: "update",
      sessionId: globs.userData.session.sessionId, body: data})
    let simpEquipTypeId=getParamId2(1900,"configuration_channels","simpSetupType")

    let arr=types.map((typ,i)=>{
      return{
        z: +this.zone.siteZoneIndex,
        c: i,
        i: simpEquipTypeId,
        f:2,
        t: Math.floor(getTime()),
        d: typ,
      }
    })
    cl(arr)
    let ret=await sendArray(arr,0,1900,0,false)
    globs.events.publish("saveOK",true)
  }

  checkTypes=()=>{
    let st=this.state
    let types=st.simpleEqTypes.slice(0)
    if(!st.simpleEqTypes.length||types[st.simpleEqTypes.length-1]){
      types.push(0)
//       cl(types)
      this.setState({simpleEqTypes:types})
    }
  }

  loadEqFromController=async(types)=>{
    var makeRequest=(c,id,zInd)=>{return({c:c,i:id,z:zInd})}
    let simpEquipTypeId=getParamId2(1900,"configuration_channels","simpSetupType")
    let sessionId=globs.userData.session.sessionId
    let siteId=this.props.parms.site
    for(let i=0;i<16;i++){
      let params=[]
      for(let j=0;j<8;j++){
        let ch=8*i+j
        params.push(makeRequest(ch,simpEquipTypeId,+this.zone.siteZoneIndex))
      }
      let pack={
        cmd:"data02",
        gwType:1900,
        params:params,
        s:siteId,
        sessionId:sessionId,
      }
      let noZero=true
      let resp=await sendSocket(pack)
      resp.params.forEach((p,j)=>{
        let ch=8*i+j
        if(+p.d){types[ch]=+p.d}
        noZero=noZero&&+p.d
      })
      if(!noZero){break}
    }
  }

  loadInfo=async()=>{
    let pa=this.props.parms
    await loadZonesInfo()
    this.zone=globs.zonesInfo.info.filter(z=>{return z.zoneId==pa.zone})[0]
    if(!this.zone){return}
    let types=[]
    await this.loadEqFromController(types)
    this.setState({loaded:true,simpleEqTypes:types})
    this.checkTypes()
  }

  onChange=(type,vals)=>{
    cl(type,vals)
    let st=this.state
    switch(type){
      case "eqSel":
        let types=st.simpleEqTypes
        types[vals.ind]=vals.eqSel
//         cl(this.simpEq)
        let eq=this.simpEq[vals.eqSel]
//         cl(eq)
        let twoCh=this.simpEq.map(e=>{return e.t}).indexOf(constant.EQ_2ND_VENT)
        if(this.twoChan.includes(eq.t)){
//           cl("two chan")
          types[vals.ind+1]=twoCh
        }else{
          if(types[vals.ind+1]==twoCh){types[vals.ind+1]=0}
        }
        this.setState({simpleEqTypes:types})
        this.checkTypes()
        globs.events.publish("savePageEnable",true)
        break
    }
  }

  showSimpleSetup=()=>{
    let st=this.state
//     cl(st)
    let rows=st.simpleEqTypes.map((t,i)=>{
      let type=this.simpEq[t]
      let opts=this.simpEq
        .filter(e=>{
          let twoCh=this.twoChan.includes(e.t)
          return !twoCh||!(i%2)
        })
        .map((e,i)=>{
          return{v:e.i,t:e.n}
        })
      opts.shift()
      return(
        <tr key={i}>
        <td style={{padding:"0px 10px 10px 0px"}}>{`Chan ${i+1}`}</td>
        <td>
        <C18Select01 style={{display:"inline-block",marginBottom:0}}
        parms={{
//           label:"Select",
          disabled:type.t==constant.EQ_2ND_VENT,
          valueName:"eqSel",
          eqSel:(st.simpleEqTypes[i]||""),
          opts:opts,
          onChange:(e,v)=>{
            Object.assign(v,{ind:i})
            this.onChange("eqSel",v)
            cl(v)
//             this.sendSystem(v.systemId)
          }//this.onChange,
        }}/>
        </td>
        </tr>
      )
    })
    return(
      <table style={{width:"initial"}}><tbody>
      {rows}
      </tbody></table>
    )
  }

  render(){
    if(this.state.loaded){
      return(
        <div>
        <h3>Simple Setup</h3>
        {this.showSimpleSetup()}
        </div>
      )
    }else{
  return <LoadingSpinner message="loading setup..." />
    }
  }
}

export default C18SimpleSetup00;
